export default __webpack_public_path__ + "static/media/program_intro_1.96150821.png";